module.exports = __webpack_public_path__ + "img/cross_orange.90604865.svg";